import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import {
  useLazyGetCognitoUsersQuery,
  useUpdateCognitoUserMutation,
} from "../../../../services/serverless";
import { getNameFromEmail } from "../../../../helpers/miscHelpers";
//import { useLazyTSUserUpdateQuery } from "../../../../services/gallus";

interface UserDetailsModalProps {
  selectedUserUsername: string | undefined;
  selectedUserEmail: string | undefined;
  modalIsOpen: boolean;
  defaultCognitoGroup: string;
  preferredUsernameIsEmail: boolean;
  toggleModal: () => void;
  rlsIsEnabled: boolean;
}

export const UserDetailsModal = (props: UserDetailsModalProps) => {
  const [userNewEmailAddress, setUserEmailAddress] = useState<string>();
  const [familyName, setFamilyName] = useState<string>();
  const [givenName, setGivenName] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  const [getUserDetailsQuery, getUserDetailsResults] =
    useLazyGetCognitoUsersQuery();
  const [updateCognitoUserMutation] = useUpdateCognitoUserMutation();
  //const [TSUserUpdate] = useLazyTSUserUpdateQuery();

  useEffect(() => {
    if (props.selectedUserUsername) {
      getUserDetailsQuery({
        cognitoUsername: props.selectedUserUsername,
        cognitoGroup: props.defaultCognitoGroup,
        nextToken: null,
      });
    }
  }, [props]);

  useEffect(() => {
    if (
      getUserDetailsResults.isSuccess &&
      getUserDetailsResults.status === "fulfilled"
    ) {
      if (getUserDetailsResults.data) {
        setUserEmailAddress(
          getUserDetailsResults.data.userList[0].email ?? "N/A",
        );
        setGivenName(
          getUserDetailsResults.data.userList[0].given_name ?? "N/A",
        );
        setFamilyName(
          getUserDetailsResults.data.userList[0].family_name ?? "N/A",
        );
        setLoading(false);
      } else {
        setErrorMessage("Userpool List Error");
        setLoading(false);
      }
    }
  }, [getUserDetailsResults]);

  const handleUpdate = async () => {
    if (userNewEmailAddress) {
      try {
        setLoading(true);
        if (props.selectedUserUsername && props.selectedUserEmail) {
          //If the email is new, then the user intends to change it. Otherwise,
          // the value is null, and the API won't even receive it. This is for
          // the impersonation checks in the backend.
          let emailAddressForAPICall =
            userNewEmailAddress === props.selectedUserEmail
              ? undefined
              : userNewEmailAddress;

          let preferredUsernameForAPICall =
            !props.rlsIsEnabled && props.preferredUsernameIsEmail
              ? userNewEmailAddress
              : undefined;

          await updateCognitoUserMutation({
            userName: props.selectedUserUsername,
            preferredUsername: preferredUsernameForAPICall,
            email: emailAddressForAPICall,
            family_name: familyName,
            given_name: givenName,
          }).unwrap();

          /*           const TSUsername = props.preferredUsernameIsEmail
            ? props.selectedUserEmail
            : props.selectedUserUsername;
          await TSUserUpdate({
            username: TSUsername,
            email: userNewEmailAddress,
            orgName: props.defaultCognitoGroup,
          }).unwrap(); */
          props.toggleModal();
          setLoading(false);
        } else {
          setLoading(false);
          setErrorMessage(`Invalid email.`);
        }
      } catch (error: any) {
        setLoading(false);
        switch (error.message) {
          case "400":
          case "500":
            setErrorMessage(
              `Email address is already in use. Please use another email address.`,
            );
            break;
          case "403":
            setErrorMessage(
              `Unauthorized action. Please log out and try again.`,
            );
            break;
          default:
            setErrorMessage(`Error updating user. Try again later.`);
            break;
        }
      }
    }
  };

  const resetValues = () => {
    setUserEmailAddress("");
    setFamilyName("");
    setGivenName("");
    setLoading(true);
  };

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Update User</ModalHeader>
      {loading && (
        <div
          style={{
            paddingBottom: "25px",
          }}
          className="loading-div"
        >
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!errorMessage && !loading && (
        <div>
          <ModalBody>
            <div>
              <div
                style={{
                  fontSize: "larger",
                  paddingBottom: "5px",
                }}
              >
                Please provide user details
                <hr></hr>
              </div>
              <div>
                <div>First Name</div>
                <input
                  type="text"
                  className="form-control formSignUpUsername"
                  value={givenName}
                  onChange={(firstNameInput) => {
                    setGivenName(firstNameInput.target.value);
                  }}
                />
                <div>Last Name</div>
                <input
                  type="text"
                  className="form-control formSignUpUsername"
                  value={familyName}
                  onChange={(lastNameInput) => {
                    setFamilyName(lastNameInput.target.value);
                  }}
                />
                <div>Email Address</div>
                <input
                  type="text"
                  className="form-control formSignUpUsername"
                  value={userNewEmailAddress}
                  onChange={(emailInput) => {
                    setUserEmailAddress(emailInput.target.value);
                  }}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              disabled={
                !userNewEmailAddress ||
                userNewEmailAddress.length === 0 ||
                getNameFromEmail(userNewEmailAddress) === null
              }
              onClick={() => {
                handleUpdate();
                resetValues();
              }}
            >
              Update user
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                props.toggleModal();
                resetValues();
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      )}
      {errorMessage && !loading && (
        <div>
          <ModalBody>{errorMessage}</ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                resetValues();
                setErrorMessage(undefined);
                props.toggleModal();
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </div>
      )}
    </Modal>
  );
};
